var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isOnixItemEmpty } from "./titleFormValues";
var hasOnixRef = function (item) {
    return !isOnixItemEmpty(item);
};
var withVersion = function (item) {
    if (!item)
        return item;
    if (item.id && (item.version === undefined || item.version === null)) {
        return __assign(__assign({}, item), { version: 0 });
    }
    return item;
};
var sanitizeOnix = function (item) {
    return hasOnixRef(item) ? withVersion(item) : undefined;
};
var sanitizePublisher = function (publisher) { return withVersion(publisher); };
var sanitizeArrayField = function (items, isValid, transform) {
    if (!items)
        return items;
    var filtered = items.filter(function (entry) { return !!entry && isValid(entry); });
    return transform ? filtered.map(transform) : filtered;
};
export var sanitizeTitlePayload = function (data) { return (__assign(__assign({}, data), { owner: sanitizePublisher(data.owner), names: sanitizeArrayField(data.names, function (_a) {
        var type = _a.type;
        return hasOnixRef(type);
    }, function (_a) {
        var type = _a.type, rest = __rest(_a, ["type"]);
        return (__assign(__assign({}, rest), { type: sanitizeOnix(type) }));
    }), languages: sanitizeArrayField(data.languages, function (_a) {
        var role = _a.role, language = _a.language;
        return hasOnixRef(role) && hasOnixRef(language);
    }, function (_a) {
        var role = _a.role, language = _a.language, rest = __rest(_a, ["role", "language"]);
        return (__assign(__assign({}, rest), { role: sanitizeOnix(role), language: sanitizeOnix(language) }));
    }), subjects: sanitizeArrayField(data.subjects, function (_a) {
        var scheme = _a.scheme;
        return hasOnixRef(scheme);
    }, function (_a) {
        var scheme = _a.scheme, rest = __rest(_a, ["scheme"]);
        return (__assign(__assign({}, rest), { scheme: sanitizeOnix(scheme) }));
    }), textContents: sanitizeArrayField(data.textContents, function (_a) {
        var type = _a.type;
        return hasOnixRef(type);
    }, function (_a) {
        var type = _a.type, language = _a.language, rest = __rest(_a, ["type", "language"]);
        return (__assign(__assign({}, rest), { type: sanitizeOnix(type), language: sanitizeOnix(language) }));
    }), supportingResources: sanitizeArrayField(data.supportingResources, function (_a) {
        var type = _a.type, mode = _a.mode;
        return hasOnixRef(type) && hasOnixRef(mode);
    }, function (_a) {
        var type = _a.type, mode = _a.mode, rest = __rest(_a, ["type", "mode"]);
        return (__assign(__assign({}, rest), { type: sanitizeOnix(type), mode: sanitizeOnix(mode) }));
    }), audiences: sanitizeArrayField(data.audiences, function (_a) {
        var type = _a.type;
        return hasOnixRef(type);
    }, function (_a) {
        var type = _a.type, rest = __rest(_a, ["type"]);
        return (__assign(__assign({}, rest), { type: sanitizeOnix(type) }));
    }), titlePublishers: sanitizeArrayField(data.titlePublishers, function (_a) {
        var publisher = _a.publisher, role = _a.role;
        return !!(publisher === null || publisher === void 0 ? void 0 : publisher.id) && hasOnixRef(role);
    }, function (_a) {
        var publisher = _a.publisher, role = _a.role, rest = __rest(_a, ["publisher", "role"]);
        return (__assign(__assign({}, rest), { publisher: sanitizePublisher(publisher), role: sanitizeOnix(role) }));
    }), titleCollections: sanitizeArrayField(data.titleCollections, function (_a) {
        var collection = _a.collection;
        return !!(collection === null || collection === void 0 ? void 0 : collection.id);
    }), titleContributions: sanitizeArrayField(data.titleContributions, function (_a) {
        var person = _a.person, unnamedPerson = _a.unnamedPerson;
        return !!(person === null || person === void 0 ? void 0 : person.id) || hasOnixRef(unnamedPerson);
    }, function (_a) {
        var unnamedPerson = _a.unnamedPerson, roles = _a.roles, rest = __rest(_a, ["unnamedPerson", "roles"]);
        return (__assign(__assign({}, rest), { unnamedPerson: sanitizeOnix(unnamedPerson), roles: sanitizeArrayField(roles, function (_a) {
                var role = _a.role;
                return hasOnixRef(role);
            }, function (_a) {
                var role = _a.role, roleRest = __rest(_a, ["role"]);
                return (__assign(__assign({}, roleRest), { role: sanitizeOnix(role) }));
            }) }));
    }) })); };
